import React from 'react';
import 'animate.css';
import "./locker_section.css";
import { useTranslation } from 'react-i18next';

function LockerSection() {

    const { t } = useTranslation("header")
    return (
        <div className="locker-section py-5 bg-light">
            <section data-aos="fade-up">
                <div className="container text-center">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="p-4 shadow-sm text-white rounded animate__animated animate__fadeIn locker-card">
                                <div>
                                    <div className="mb-4 animate__animated animate__fadeInRight">
                                        <h2 className="fw-bold text-white">{t("locker_service")}</h2>
                                    </div>
                                    <p className="mb-4 fs-5 text-white animate__animated animate__fadeInLeft">
                                    {t("locker_first_desc")}<br />
                                    {t("locker_second_desc")}
                                    </p>
                                    <p className="mb-4 fs-5 text-white animate__animated animate__fadeInLeft">
                                    {t("locker_condition")}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default LockerSection;
